import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentsService } from '../../payments.service';
import { Payment } from '../../payments.models';
import { Location } from '@angular/common';

@Component({
  selector: 'app-payment-details',
  standalone: false,
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss',
})
export class PaymentDetailsComponent implements OnInit {
  paymentId: string | null = null;
  payment: Payment | null = null;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentsService: PaymentsService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.paymentId = this.route.snapshot.paramMap.get('id');
    if (this.paymentId) {
      this.loadPaymentDetails(this.paymentId);
    }
  }

  loadPaymentDetails(id: string): void {
    this.isLoading = true;
    this.paymentsService.get(id).subscribe({
      next: data => {
        this.payment = data;
        this.isLoading = false;
      },
      error: error => {
        console.error('Error fetching payment details', error);
        this.isLoading = false;
        // Handle error (e.g. not found)
      },
    });
  }

  goBack(): void {
    this.location.back();
  }
}
